import React from "react"
import { StyledIcon } from "../StyledIcon"

// eslint-disable-next-line import/prefer-default-export
const EmailUsWmoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="13"
    viewBox="0 0 15 13"
    fill="none"
  >
    <path
      d="M1.72266 2.78394L7.50043 7.04507L13.2782 2.78394"
      stroke="white"
      stroke-width="1.44445"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5556 1.55615H2.44444C1.6467 1.55615 1 2.20285 1 3.0006V10.2229C1 11.0206 1.6467 11.6673 2.44444 11.6673H12.5556C13.3533 11.6673 14 11.0206 14 10.2229V3.0006C14 2.20285 13.3533 1.55615 12.5556 1.55615Z"
      stroke="white"
      stroke-width="1.44445"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export default EmailUsWmoIcon
